module.exports = function() {
  return new Worker(__webpack_public_path__ + "c5c119762faaaa1c2363.worker.js");
};